import { LANG_V2_REP_SEC, REP_SEC } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";
import { SEC_FORM_SCHEMA } from "./utils";

export class ReportSection extends LanguageCategory{
  constructor(data){
    super(data)
    this.type = ReportSection.getTypeDir()
    this.childTypes = ReportSection.getChildTypes()
  }

  getDisplayText(){
    return `Section ${this.number} - ${this.content}`
  }

  static getTypeDir(){ return REP_SEC }
  static getChildTypes(){ return [] }
  static getRelType(){ return LANG_V2_REP_SEC }

  static getFormKeys(){
    return ['content', 'number']
  }

  getFormData(){
    return LanguageCategory.getFormData(ReportSection, this)
  }

  static getParentKey(){
    return false
  }

  static getParentAddress(){
    return false
  }

  getTypeAddress(){
    return LanguageCategory.getTypeAddress(ReportSection)
  }
  static getTypeAddress(){
    return LanguageCategory.getTypeAddress(ReportSection)
  }

  static getFormColWidths(){
    return {
      number:6,
      content:6
    }
  }

  static getFormSchema(){
    return SEC_FORM_SCHEMA
  }

  static constructFromDBData(data){
    return new ReportSection(super.constructFromDBData(data, ReportSection.getTypeDir()))
    
  }

  static getMongooseSchema(mongoose, Schema){
    return super.getMongooseSchema(mongoose, Schema, {
      number: {type:String}
    })
  }

}